const defaultColumn = {
  title: 'Untitled',
  columnStart: 1,
  rowStart: 1,
  rowEnd: 4,
  columnEnd: 4,
  width: 'auto',
  height: 'auto',
  vAlign: 'center',
  hAlign: 'center',
  photo: {
    path: '',
    url: ''
  },
  imagePosition: 'Center',
  imageAppearance: 'Contain'
};

export default defaultColumn;



// WEBPACK FOOTER //
// ./src/containers/add/defaultColumn.js